import React from "react";
import ReactModal from "react-modal";

const CityChangePopup = ({
  showCityChange,
  handleCityChangeClose,
  handleCityChangeConfirm,
}: {
  showCityChange: boolean;
  handleCityChangeClose: () => void;
  handleCityChangeConfirm: () => void;
}) => {
  return (
    <ReactModal
      isOpen={showCityChange}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          height: "280px",
          padding: "0px 20px",
          paddingTop: "10px",
          borderRadius: "8px",
        },
      }}
    >
      <div className="text-center">
        <img src="/assets/img/location-address.png" alt="" width={"80px"} />
        <p className="mt-3"> Are you sure you want to change the city?</p>
        <p className="mt-1 mb-3">
          Changing the city will update the test prices and availability based on the selected City
        </p>
      </div>
      <div className="d-flex justify-content-center">
        <button onClick={() => handleCityChangeClose()} type="button" className="book--hexagon active m-0">
          <span className="text-capitalize">No</span>
        </button>
        <button onClick={handleCityChangeConfirm} className="book--hexagon active m-0 ml-3">
          <span className="text-capitalize">Yes</span>
        </button>
      </div>
    </ReactModal>
  );
};

export default CityChangePopup;
